import apiWrapper from 'Helpers/apiWrapper'
// import { encodeParams } from 'mailup-react-helpers'
// import extractApiData from 'Helpers/extractApiData'

const endpoints = ((baseURL) => {
  return {

    getPresignedUrlPutObject: (expiresIn) => `${baseURL}/api/presign/put/expiration/${expiresIn}`,
    getPresignedUrlObject: (expiresIn, filePath) => `${baseURL}/api/expiration/${expiresIn}/presign${filePath}`

  }
})(process.env.BESTORAGE_URL)

export const getPresignedUrlPutObject = (expiresIn) => {
  const url = endpoints.getPresignedUrlPutObject(expiresIn)

  return apiWrapper({
    method: 'get',
    url: url
  }).then((res) => res.data)
}

export const getPresignedUrlObject = (expiresIn, filePath) => {
  const url = endpoints.getPresignedUrlObject(expiresIn, filePath)

  return apiWrapper({
    method: 'get',
    url: url
  }).then((res) => res.data)
}
